/**
 * Recado: a mensagem passageira no canto da tela.
 *
 * ═══ POR QUE NÃO ERA `AvisosAoVivo` ═══
 *
 * Porque aquilo é do domínio de ALERTA — chega pela conexão de eventos,
 * carrega foto do objeto e leva para `/avisos` ao ser clicado. Um "falta
 * o nome" entrando naquela pilha seria uma ocorrência de câmera que não
 * aconteceu, no mesmo lugar onde aparece invasão de madrugada. Misturar
 * os dois é o jeito de fazer alguém parar de ler os dois.
 *
 * ═══ POR QUE UM BARRAMENTO, E NÃO PROPRIEDADE PASSADA DE MÃO EM MÃO ═══
 *
 * Porque quem precisa avisar é sempre um formulário no fim de uma pilha
 * de componentes, e quem desenha o recado tem de morar FORA das telas —
 * senão ele é cortado pelo primeiro `overflow: hidden` do caminho. É o
 * mesmo desenho de `Dica` e `Paleta`, e pela mesma razão.
 *
 * Uso:
 *     import { recado } from '../recado'
 *     recado.erro('Complete o que falta para gravar: o nome.')
 */

export type TipoDeRecado = 'erro' | 'ok' | 'aviso'

export interface Recado {
  id: number
  tipo: TipoDeRecado
  texto: string
}

type Ouvinte = (r: Recado) => void

const ouvintes = new Set<Ouvinte>()

/* Contador próprio, e não `Date.now()`: dois recados disparados no mesmo
   milissegundo — o que acontece quando uma validação reprova dois campos
   — teriam a MESMA chave de lista, e o React descartaria o segundo
   calado. */
let proximo = 1

function emitir(tipo: TipoDeRecado, texto: string) {
  const r: Recado = { id: proximo++, tipo, texto }
  for (const o of ouvintes) o(r)
  return r
}

export const recado = {
  erro: (texto: string) => emitir('erro', texto),
  aviso: (texto: string) => emitir('aviso', texto),
  ok: (texto: string) => emitir('ok', texto),
}

/** Quem desenha os recados se inscreve aqui. Devolve o cancelamento. */
export function ouvirRecados(fn: Ouvinte): () => void {
  ouvintes.add(fn)
  return () => { ouvintes.delete(fn) }
}
